// used in htwapartmentexchange
document.body.addEventListener('input', function (e) {
  const numberFields = [
    'apartmentexchange-10726-text-4',
    'apartmentexchange-10726-text-9',
    'apartmentexchange-10726-text-10',
  ];
  if (numberFields.includes(e.target.id)) {
    const match = e.target.value.match(/^\d*([,.]\d{0,2})?/);
    e.target.value = match ? match[0].replace(',', '.') : '';
  }
});

document.body.addEventListener('paste', function (e) {
  if (numberFields.includes(e.target.id)) {
    setTimeout(() => e.target.dispatchEvent(new Event('input')), 0);
  }
});
